/**
 * Shared utilities for PostHog invite tracking
 */

export type InviteSource =
  | 'favorites'
  | 'worked_with'
  | 'new_to_you'
  | 'dashboard'
  | 'shifts_open'
  | 'shifts_action_needed'
  | 'shift_details'
  | 'schedule_list'
  | 'request_shift'
  | 'unknown';

export type InviteType = 'new_shift' | 'existing_shift' | 're_book';

export type LocationCategory =
  | 'professional_hub'
  | 'dashboard'
  | 'shifts_overview'
  | 'shift_details'
  | 'schedule'
  | 'request_form'
  | 'other';

/**
 * Get the location category for a given invite source
 * Single source of truth for categorizing invite sources
 */
export const getInviteLocationCategory = (source: InviteSource | string | undefined): LocationCategory => {
  if (!source) return 'other';

  // Professional Hub sources
  if (['favorites', 'worked_with', 'new_to_you'].includes(source)) {
    return 'professional_hub';
  }

  // Dashboard source
  if (source === 'dashboard') {
    return 'dashboard';
  }

  // Shifts Overview sources
  if (['shifts_open', 'shifts_action_needed'].includes(source)) {
    return 'shifts_overview';
  }

  // Shift Details page
  if (source === 'shift_details') {
    return 'shift_details';
  }

  // Schedule list view
  if (source === 'schedule_list') {
    return 'schedule';
  }

  // Request a Shift form
  if (source === 'request_shift') {
    return 'request_form';
  }

  return 'other';
};